<template>
  <div class="mainpage">
    <div class="mainView">
		<div class="heroEllipses" aria-hidden="true">
			<img class="heroEllipse heroEllipseSmall" src="@/assets/home-hero-ellipse-8.png" alt="">
			<img class="heroEllipse heroEllipseMedium" src="@/assets/home-hero-ellipse-9.png" alt="">
			<img class="heroEllipse heroEllipseLarge" src="@/assets/home-hero-ellipse-10.png" alt="">
		</div>
		<div class="heroContent">
			<h1 class="juxiuTitle">
                <img src="/img/systitle.svg" alt="数智治理与智慧软件解决方案服务商" />
            </h1>
			<div class="heroStats" aria-label="聚秀科技服务数据">
				<div class="heroStat">
					<span class="statValue">10<span class="statUnit statPlus">+</span></span>
					<span class="statLabel">年专业领域</span>
				</div>
				<span class="statDivider" aria-hidden="true"></span>
				<div class="heroStat">
					<span class="statValue">4<span class="statUnit">w+</span></span>
					<span class="statLabel">合作用户</span>
				</div>
			</div>
		</div>
    </div>
    <div class="businessInfo">
        <div class="business_title">
            <div class="title">1+N：业务发展方向</div>
            <div class="subtext">多跨融合 智慧治理</div>
        </div>
        <div class="businessDiagram">
            <div class="jxsmartClound">
                <div class="smartName">聚秀数智云</div>
            </div>
            <div class="smartBg" aria-label="聚秀数智云业务领域">
                <button
                    v-for="(item, index) in businessArr"
                    :key="item.name"
                    type="button"
                    :class="['business_item', `business_item-${index + 1}`]"
                    @click="goToBusiness(item.path)"
                >{{ item.name }}</button>
            </div>
        </div>
    </div>
    <div class="applicationCases">
        <div class="business_title">
            <div class="title">应用案例</div>
            <div class="subtext">服务的用户遍布全国</div>
        </div>
        <div class="caseGrid">
            <router-link
                v-for="item in applicationCases"
                :key="item.name"
                class="caseCard"
                :to="{ path: '/caseDetails', query: { id: item.id, title: item.name } }"
                :aria-label="`查看${item.name}案例详情`"
            >
                <div class="caseImageWrap">
                    <img class="caseImage" :src="item.image" :alt="item.name">
                </div>
                <div class="caseContent">
                    <div class="caseName">{{ item.name }}</div>
                    <div class="caseLine"></div>
                    <span class="caseCategory">{{ item.category }}</span>
                </div>
            </router-link>
        </div>
    </div>
    <div class="advantage">
        <div class="business_title">
            <div class="title">万千客户的信任与选择</div>
            <div class="subtext">全国各省市布局，服务政府国企数字化转型</div>
        </div>
        <div class="customerGroups" role="list" aria-label="合作客户">
			<div
				v-for="group in customerGroups"
				:key="group.id"
				:class="['customerGroup', { 'customerGroup--wide': group.columns === 2, 'customerGroup--summary': group.remainder }]"
				role="listitem"
			>
				<div class="customerItems" role="list">
					<div v-for="item in group.items" :key="item" class="customerItem" role="listitem">{{ item }}</div>
				</div>
				<div v-if="group.remainder" class="customerRemainder" aria-hidden="true">{{ group.remainder }}</div>
			</div>
        </div>
    </div>
    <div class="thenews">
        <div class="business_title">
            <div class="title">资讯动态</div>
            <div class="subtext">关注聚秀发展，聚焦行业动态</div>
        </div>    
        <div class="content">
            <div class="left_photo">
                <el-carousel trigger="click" @change='change'>
                    <el-carousel-item v-for="(item,index) in newsArr" :key="index" >
                        <!-- <img :src="item.url" /> -->
                        <el-image
                            style="width: 100%; height: 100%"
                            :src="require('/public/img/dynamic/' + item.img)"
                            fit="cover">
                        </el-image>
                        <!-- <div class="text">{{item.text}}</div> -->
                    </el-carousel-item>
                </el-carousel>
                
            </div>
            <div class="right_content">
                <div class="right_block">
                    <div class="content_row" v-for="(item,index) in newsArr" :key="index">
                        <div class="date">{{item.time}}</div>
                        <div @click="onCardClick(item)" :style="currentIndex==index?'color:#FF795B':''" class="newscontent">{{item.title}}</div>
                    </div>
                </div>    
                <div class="content_more" @click="gotoMore">
                    <div class="more_btn">
                        查看更多 
                    </div>
                </div>
                
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import {micData} from '@/views/dynamic/micData'
export default {
    data(){
        return{
            currentIndex:0,
            businessArr:[
                { name: '智慧国资', path: '/stateOwnedAssets' },
                { name: '智慧国企', path: '/stateOwnedEnterprise' },
                { name: '资产云', path: '/assetCloud' },
                { name: '人工智能', path: '/ai' },
                { name: '智慧监管', path: '/intelligentSupervision' },
                { name: '智慧好管家', path: '/goodHousekeeper' }
            ],
            applicationCases: [
                { id: 26, name: '顺义区国资委', category: '智慧国资', image: require('@/assets/case-shunyi.png') },
                { id: 22, name: '温州市国资委', category: '智慧国资', image: require('@/assets/case-wenzhou.png') },
                { id: 21, name: '杭州市国资委', category: '智慧国资', image: require('@/assets/case-hangzhou.png') },
                { id: 24, name: '舟山市国资委', category: '智慧国资', image: require('@/assets/case-zhoushan.png') },
                { id: 23, name: '衢州市国资委(在建)', category: '智慧国资', image: require('@/assets/case-quzhou.png') }
            ],
			customerGroups: [
				{
					id: 'city-assets',
					columns: 1,
					items: ['杭州市国资委', '温州市国资委', '台州市国资委', '湖州市国资委', '衢州市国资委', '...']
				},
				{
					id: 'district-assets',
					columns: 2,
					items: [
						'西湖区国资办', '拱墅区国资办',
						'萧山区国资办', '余杭区国资办',
						'钱塘区国资办', '北仑区国资中心',
						'乐清市国资办', '鹿城区国资办',
						'温岭市国资办', '安吉县国资办',
						'定海区国资办', '...'
					]
				},
				{
					id: 'regional-assets',
					columns: 1,
					items: ['顺义区国资委', '房山区国资委', '萍乡市国资委', '望城区国资办', '宁乡市国资办', '...']
				},
				{
					id: 'investment-groups',
					columns: 1,
					items: ['东阳国投集团', '临海国投', '滨海新区管委会'],
					remainder: '......'
				}
			],
            newsArr:[
                // {date:'2022-11-12',text:"浙江省国资委推出国资交易质量提升“十件事”",url:'/img/news/news1.png'},
                // {date:'2022-11-12',text:'完善平台智能录入、统计、检索、客服、审核、监测和线上签约、线上鉴证、资金结算等功能，提高平台智能化水平',url:'/img/news/news2.png'},
                // {date:'2022-11-12',text:'浙江省国资委推出国资交易质量提升“十件事”',url:'/img/news/news3.png'}
            ]
        }
    },
    mounted(){
       this.newsArr = micData.slice(0,3)
    },
    methods:{
        goToBusiness(path) {
            this.$router.push(path)
        },
        gotoMore(){
            this.$router.push('./caseDynamic')
        },
        onCardClick(item) {
            window.open(item.url)
        },
        change(item,item1){
            this.currentIndex = item
        }
    }
}
</script>

<style lang="scss" scoped>
.mainpage{
    height: 100%;
    width: 100%;
    overflow: hidden;
    .mainView{
        background: url('~@/assets/home-hero-city.png') center center / cover no-repeat;
        width: 100%;
        height: 460px;
        position: relative;
        overflow: hidden;
        text-align: left;
        .heroEllipses{
            position: absolute;
            inset: 0;
            pointer-events: none;
        }
        .heroEllipse{
            position: absolute;
            display: block;
        }
        .heroEllipseSmall{
            top: 68px;
            left: 50%;
            width: 24px;
            height: 24px;
        }
        .heroEllipseMedium{
            top: 236px;
            left: 35%;
            width: 47px;
            height: 49px;
        }
        .heroEllipseLarge{
            top: 112px;
            left: 56.25%;
            width: 76px;
            height: 78px;
        }
        .heroContent{
            position: relative;
            z-index: 1;
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            padding: 135px 0 0 8.33%;
        }
        .juxiuTitle{
            margin: 0;
            font-family: Source Han Sans CN Medium;
            font-weight: bold;
            font-size: 56px;
            color: #333131;
            line-height: 67px;
            letter-spacing: 4px;
            text-align: left;
            font-style: normal;
            white-space: nowrap;
        }
        .heroStats{
            display: flex;
            align-items: center;
            margin-top: 44px;
            height: 56px;
        }
        .heroStat{
            display: flex;
            align-items: baseline;
            white-space: nowrap;
        }
        .statValue{
            font-family: PingFangSC, 'PingFang SC', sans-serif;
            font-size: 48px;
            font-weight: 600;
            line-height: 67px;
            color: #FF4A00;
            font-style: normal;
            background: linear-gradient(0deg, #FF4A00 0%, #FF7C16 100%);
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
        }
        .statUnit{
            margin-left: 2px;
            font-size: 20px;
            line-height: 28px;
        }
        .statPlus{
            margin-left: 0;
            font-size: 30px;
        }
        .statLabel{
            margin-left: 12px;
            font-family: Source Han Sans CN Medium;
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
            color: #333333;
        }
        .statDivider{
            width: 1px;
            height: 44px;
            margin: 0 64px;
            background: rgba(105, 105, 105, 0.24);
        }
    }
    .businessInfo{
        padding-top: 45px;
        width: 100%;
        height: 640px;
        position: relative;
        display: flex;
        justify-content: center;
        .business_title{
            .title{
                font-size: 32px;
                font-family: Source Han Sans CN Medium;
                font-weight: 600;
                color: #333333;
                line-height: 45px;
            }
            .subtext{
                padding-top: 11px;
                font-size: 18px;
                font-family: Source Han Sans CN Normal;
                font-weight: 400;
                color: #666666;
            }
        }
        .businessDiagram{
            position: absolute;
            top: 174px;
            left: 50%;
            width: min(61.51%, 1181px);
            height: 360px;
            transform: translateX(-50%);
        }
        .jxsmartClound{
            position: absolute;
            z-index: 1;
            top: 0;
            left: 50%;
            width: 337px;
            height: 218px;
            transform: translateX(-50%);
            background: url('~@/assets/数智云.png') center / 100% 100% no-repeat;
            .smartName{
                position: absolute;
                top: 225px;
                left: 50%;
                white-space: nowrap;
                transform: translateX(-50%);
                font-size: 24px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #333333;
                line-height: 33px;
            }
        }
        .smartBg{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: url('~@/assets/圆环.png') center / 100% 100% no-repeat;
            .business_item{
                width: 180px;
                height: 44px;
                display: flex;
                padding-left: 54px;
                align-items: center;
                border: 0;
                cursor: pointer;
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 25px;
                text-align: left;
                background: url('~@/assets/边框.png') center / 100% 100% no-repeat;
                position: absolute;
                transition: transform 200ms ease-out;
                &:hover{
                    transform: translateY(-2px);
                }
                &:focus{
                    outline: none;
                }
                &:focus-visible{
                    color: #FF795B;
                }
            }
            .business_item-1{
                top: 137px;
                left: -90px;
            }
            .business_item-2{
                top: 216px;
                left: calc(20% - 120px);
            }
            .business_item-3{
                top: 296px;
                left: calc(40% - 150px);
            }
            .business_item-4{
                top: 137px;
                right: -90px;
            }
            .business_item-5{
                top: 216px;
                right: calc(20% - 130px);
            }
            .business_item-6{
                top: 296px;
                right: calc(40% - 170px);
            }
        }
    }
    .applicationCases{
        box-sizing: border-box;
        width: 100%;
        padding: 47px 10px 76px;
        background: #F4F6F8;
        .business_title{
            .title{
                margin: 0;
                font-size: 32px;
                font-family: Source Han Sans CN Medium;
                font-weight: 600;
                color: #333333;
                line-height: 45px;
            }
            .subtext{
                padding-top: 11px;
                font-size: 18px;
                font-family: Source Han Sans CN Normal;
                font-weight: 400;
                color: #666666;
                line-height: 25px;
            }
        }
        .caseGrid{
            display: grid;
            grid-template-columns: repeat(5, minmax(0, 1fr));
            gap: 22px;
            max-width: 1840px;
            margin: 42px auto 0;
        }
        .caseCard{
            min-width: 0;
            overflow: hidden;
            background: #FFFFFF;
            text-align: left;
            text-decoration: none;
            cursor: pointer;
            transition: box-shadow 200ms ease-out, transform 200ms ease-out;
            &:hover{
                box-shadow: 0 8px 20px rgba(114, 114, 119, 0.18);
                transform: translateY(-2px);
            }
            &:focus-visible{
                outline: 3px solid rgba(255, 121, 91, 0.55);
                outline-offset: 3px;
            }
        }
        .caseImageWrap{
            overflow: hidden;
            aspect-ratio: 2 / 1;
        }
        .caseImage{
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        .caseCard:first-child .caseImage{
            width: 106.977%;
            max-width: none;
            margin-left: -6.977%;
        }
        .caseCard:last-child .caseImage{
            width: 106.977%;
            max-width: none;
            margin-left: 0;
        }
        .caseContent{
            box-sizing: border-box;
            padding: 20px 16px 24px;
            text-align: left;
        }
        .caseName{
            min-height: 22px;
            margin: 0;
            overflow: hidden;
            font-size: 16px;
            font-family: Source Han Sans CN Medium;
            font-weight: 600;
            color: #333333;
            line-height: 22px;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .caseLine{
            height: 1px;
            margin-top: 16px;
            border-top: 1px solid rgba(212, 212, 212, 0.5);
        }
        .caseCategory{
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 64px;
            height: 24px;
            margin-top: 12px;
            background: rgba(255, 169, 43, 0.15);
            border-radius: 4px;
            font-size: 12px;
            font-family: Source Han Sans CN Regular;
            font-weight: 400;
            color: #FFA92B;
            line-height: 24px;
        }
    }
    .advantage{
		box-sizing: border-box;
        width: 100%;
        height: 752px;
		background: url('~@/assets/home-advantage-bg.png') center / cover no-repeat;
        position: relative;
        display: flex;
        flex-direction: column;
		align-items: center;
        .business_title{
			box-sizing: border-box;
			padding-top: 68px;
            .title{
                font-size: 32px;
                font-family: Source Han Sans CN Medium;
                font-weight: 600;
                color: #333333;
                line-height: 45px;
            }
            .subtext{
                padding-top: 11px;
                font-size: 18px;
                font-family: Source Han Sans CN Normal;
                font-weight: 400;
                color: #666666;
				line-height: 25px;
            }
        }
		.customerGroups{
			display: grid;
			grid-template-columns: 204px 376px 204px 204px;
			gap: 40px;
			margin-top: 54px;
		}
		.customerGroup{
			box-sizing: border-box;
			width: 204px;
			height: 453px;
			padding: 20px 24px;
			border-radius: 12px;
			background: rgba(255, 255, 255, 0.72);
		}
		.customerGroup--wide{
			width: 376px;
		}
		.customerItems{
			display: grid;
			grid-template-columns: 1fr;
			gap: 18px;
		}
		.customerGroup--wide .customerItems{
			grid-template-columns: repeat(2, minmax(0, 1fr));
			column-gap: 18px;
		}
		.customerItem,
		.customerRemainder{
			display: flex;
			align-items: center;
			justify-content: center;
			box-sizing: border-box;
			height: 52px;
			border-radius: 6px;
			background: rgba(255, 240, 228, 0.88);
			font-size: 16px;
			font-family: Source Han Sans CN Medium;
			font-weight: 500;
			color: #FF5E2C;
			line-height: 22px;
			white-space: nowrap;
		}
		.customerGroup--summary{
			display: flex;
			flex-direction: column;
		}
		.customerGroup--summary .customerItems{
			flex: none;
		}
		.customerRemainder{
			flex: 1;
			width: 100%;
			height: auto;
			min-height: 120px;
			margin-top: 18px;
		}
    }
    .thenews{
        width: 100%;
        height: 720px;
        position: relative;
        display: flex;
        flex-direction: column;
        padding-bottom: 122px;
        .business_title{
            padding-top: 60px;
            .title{
                font-size: 32px;
                font-family: Source Han Sans CN Medium;
                font-weight: 600;
                color: #333333;
                line-height: 45px;
            }
            .subtext{
                padding-top: 11px;
                font-size: 18px;
                font-family: Source Han Sans CN Normal;
                font-weight: 400;
                color: #666666;
            }
        }
        .content{
            width: 100%;
            height: calc(100% - 142px);
            padding: 2.8% 16.67% 0 16.67%;
            display: flex;
            justify-content: space-between;
        }
        .left_photo{
            width: 42%;
            height: 100%;
            display: flex;
            .el-carousel{
                width: 100%;
                height: calc(100% - 0.3rem) !important;
                overflow: hidden;
            }
            .el-carousel__container{
                height: calc(100% - 0px) !important;
            }
            .el-carousel__item {
                width: 100%;
                height: 100%;
                img{
                    width: 100%;
                }
            }
            .el-carousel__indicators--horizontal {
                bottom: 0px;
                left: 50%;
                transform: translateX(-50%);
            }
            .text{
                position: absolute;
                font-size: 16px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #333333;
                line-height: 22px;
                bottom: -20px;
                width: 100%;
                display: flex;
                justify-content: center;
            }
        }
        .right_content{
            padding-left: 100px;
            height: 100%;
            flex: 1;
            display: flex;
            flex-direction: column;
            .right_block{
                height: calc(100% - 60px);
                display: flex;
                flex-direction: column;
                align-items: flex-start;
            }
            .content_more{
                width: 100%;
                height: 60px;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                .more_btn{
                    cursor: pointer;
                    width: 144px;
                    height: 60px;
                    background: url('/public/img/morebtnbg.png');
                    background-size: 100% 100%;
                    font-size: 16px;
                    font-family: Source Han Sans CN Medium;
                    color: #FFFFFF;
                    line-height: 22px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: relative;
                    &::after{
                        content: '';
                        display: block;
                        position: absolute;
                        top: -36px;
                        left: -100px;
                        background: white;
                        width: 50px;
                        height: 125px;
                        opacity: 20%;
                        transform: rotate(-45deg);
                    }
                    &:hover::after{
                        left: 120%;
                        transition: all 2s cubic-bezier(0.3, 1, 0.2, 1);
                    }
                }
            }
            .content_row{
                border-top: 1px solid #D4D4D4;
                padding: 15px 0;
                width: 100%;
                flex: 1;
                
                
                .date{
                    text-align: left;
                    font-size: 14px;
                    font-family: Source Han Sans CN Regular;
                    font-weight: 400;
                    color: #666666;
                    line-height: 20px;
                    padding-bottom: 16px;
                }
                .newscontent{
                    font-size: 16px;
                    font-family: Source Han Sans CN Bold;
                    font-weight: 600;
                    color: #333333;
                    line-height: 22px;
                    cursor: pointer;
                    text-align: left;
                }
                &:nth-last-child(n){
                    border-bottom: 1px solid #D4D4D4;
                }
                &:hover{
                    .date{
                        color: #333;
                        font-weight: 700;
                    }
                    .newscontent{
                        color: rgb(40,120,255) !important;
                    }
                }
            }
        }
    }
    
}
</style>
